import { ReactElement, ReactNode } from 'react';
import { DisconnectedMachineContent } from './components/DisconnectedMachineContent';
import { EconomyModeBar } from './components/EconomyModeBar';
import { SetpointContainer } from './styles';
import { ScheduleHoursContent } from './components/ScheduleHoursContent';
import { ErrorMachines } from '../MachinesList/components/ErrorsMachines';
import { useTranslation } from 'react-i18next';

interface ProfileContentProps {
  automationIntervals: {startTime: string, endTime: string}[];
  checkAutomaticMode: boolean;
  onClickCheckAutomaticMode: () => void;
  connection: boolean;
  generalLoading: boolean;
  isOutOfSchedule: boolean;
  isError: boolean;
  children: ReactNode;
  openEconomyModeOffModal: boolean;
  onCloseEconomyModeOff: () => void;
}

export function ProfileContent({
  automationIntervals,
  checkAutomaticMode,
  connection,
  generalLoading,
  isOutOfSchedule,
  isError,
  onClickCheckAutomaticMode,
  children,
  openEconomyModeOffModal,
  onCloseEconomyModeOff,
}: ProfileContentProps): ReactElement {
  const { t } = useTranslation();

  if (isError && !generalLoading) {
    return <ErrorMachines customText={t('erroCarregarMaquina')} />;
  }

  if (!connection && !generalLoading) {
    return <DisconnectedMachineContent />;
  }

  return (
    <>
      {!isOutOfSchedule && (
        <EconomyModeBar
          checked={checkAutomaticMode}
          onClickCheck={onClickCheckAutomaticMode}
          loading={generalLoading}
          openEconomyModeOffModalByManualMode={openEconomyModeOffModal}
          onCloseEconomyModeOff={onCloseEconomyModeOff}
        />
      )}
      <SetpointContainer>
        {children}
      </SetpointContainer>
      <ScheduleHoursContent
        automationIntervals={automationIntervals}
        loading={generalLoading}
      />
    </>
  );
}
